import {
  ARTWORK_FONT_FAMILY,
  ARTWORK_FONT_WEIGHT,
  ARTWORK_HEIGHT,
  ARTWORK_WIDTH,
  IDENTITY_COLORS,
  MYBUILDID_RED,
  OFFICIAL_HORIZONTAL_LOGO,
  SAFE_MARGIN
} from "./merchArtworkConstants";

const TONES = ["dark", "light"];
const FRONT_LOGO_WIDTH = 1350;
const FRONT_LOGO_HEIGHT = FRONT_LOGO_WIDTH / OFFICIAL_HORIZONTAL_LOGO.aspectRatio;

export const identityArtworkMetadata = {
  width: ARTWORK_WIDTH,
  height: ARTWORK_HEIGHT,
  safeMargin: SAFE_MARGIN,
  front: {
    recommendedPrintWidthInches: 4,
    supportedGarmentColors: {
      dark: ["Faded Black", "Faded Coal"],
      light: ["Faded Bone"]
    },
    filenames: {
      dark: "mybuildid-identity-front-dark.svg",
      light: "mybuildid-identity-front-light.svg"
    },
    pngFilenames: {
      dark: "mybuildid-identity-front-dark.png",
      light: "mybuildid-identity-front-light.png"
    }
  },
  back: {
    recommendedPrintWidthInches: 11,
    supportedGarmentColors: {
      dark: ["Faded Black", "Faded Coal"],
      light: ["Faded Bone"]
    },
    filenames: {
      dark: "mybuildid-identity-back-dark.svg",
      light: "mybuildid-identity-back-light.svg"
    },
    pngFilenames: {
      dark: "mybuildid-identity-back-dark.png",
      light: "mybuildid-identity-back-light.png"
    }
  }
};

function validateTone(garmentTone) {
  if (!TONES.includes(garmentTone)) {
    throw new Error(`Unsupported garmentTone "${garmentTone}". Use "dark" or "light".`);
  }
  return IDENTITY_COLORS[garmentTone];
}

function escapeXmlAttribute(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function svgShell(content, label) {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${ARTWORK_WIDTH}" height="${ARTWORK_HEIGHT}" viewBox="0 0 ${ARTWORK_WIDTH} ${ARTWORK_HEIGHT}" role="img" aria-label="${escapeXmlAttribute(label)}">
  <title>${label}</title>
  ${content}
</svg>`;
}

export function createIdentityFrontSvg({ garmentTone }) {
  validateTone(garmentTone);
  const logoX = (ARTWORK_WIDTH - FRONT_LOGO_WIDTH) / 2;
  const logoY = (ARTWORK_HEIGHT - FRONT_LOGO_HEIGHT) / 2;

  return svgShell(
    `<image href="${OFFICIAL_HORIZONTAL_LOGO.dataUrl}" x="${logoX}" y="${logoY}" width="${FRONT_LOGO_WIDTH}" height="${FRONT_LOGO_HEIGHT}" preserveAspectRatio="xMidYMid meet" />`,
    `MyBuildID Identity Tee front artwork for ${garmentTone} garments`
  );
}

export function createIdentityBackSvg({ garmentTone }) {
  const palette = validateTone(garmentTone);
  const fontFamily = escapeXmlAttribute(ARTWORK_FONT_FAMILY);

  return svgShell(
    `<g font-family="${fontFamily}" font-weight="${ARTWORK_FONT_WEIGHT}">
    <text x="2250" y="2800" fill="${palette.watermark}" font-size="1040" letter-spacing="-52" text-anchor="middle">MBID</text>
    <rect x="600" y="700" width="210" height="30" fill="${MYBUILDID_RED}" />
    <text x="600" y="1290" fill="${palette.main}" font-size="560" letter-spacing="18">VEHICLE</text>
    <text x="570" y="2150" fill="${palette.main}" font-size="900" letter-spacing="-34">IDENTITY.</text>
    <g fill="${palette.secondary}" font-size="330" letter-spacing="24">
      <text x="600" y="3300">DOCUMENT.</text>
      <text x="600" y="3730">BUILD.</text>
      <text x="600" y="4160">INSPIRE.</text>
    </g>
  </g>`,
    `MyBuildID Identity Tee back artwork for ${garmentTone} garments`
  );
}

// Development-only helper: generates all four SVG strings without adding production UI.
export function createAllIdentityArtworkSvgs() {
  return {
    "mybuildid-identity-front-dark.svg": createIdentityFrontSvg({ garmentTone: "dark" }),
    "mybuildid-identity-front-light.svg": createIdentityFrontSvg({ garmentTone: "light" }),
    "mybuildid-identity-back-dark.svg": createIdentityBackSvg({ garmentTone: "dark" }),
    "mybuildid-identity-back-light.svg": createIdentityBackSvg({ garmentTone: "light" })
  };
}
